import { atomWithStorage } from "jotai/utils";

export interface CachedItem<T = unknown> {
  data: T;
  timestamp: number;
}

export const tcCodeCacheAtom = atomWithStorage<Record<string, CachedItem>>("searchVesselsTcCodeCache", {});
